import type { ClassValue } from "clsx";
import { cn } from "../lib/utils";

const baseOptionClassName: ClassValue =
	"flex items-center justify-center rounded-[3px] w-[41px] h-[21px] border border-transparent text-gray-400/80 text-[11px]";
const activeOptionClassName: ClassValue =
	"border-gray-500 text-gray-800 text-[11px] font-[600] shadow-sm bg-gray-50";

export const YesNoDisplay = ({
	value,
	inactiveClassName,
}: {
	value?: boolean | null;
	inactiveClassName?: string;
}) => {
	if (value === undefined || value === null) return "--";
	return (
		<div className="flex text-[12px] font-[450] box-content select-none">
			<div
				className={cn(
					baseOptionClassName,
					value === true ? activeOptionClassName : ["mr-[4px]", inactiveClassName],
				)}
			>
				YES
			</div>
			<div
				className={cn(
					baseOptionClassName,
					value === false ? activeOptionClassName : inactiveClassName,
				)}
			>
				NO
			</div>
		</div>
	);
};
